module.exports = __webpack_public_path__ + "static/media/climbing_view_1366.562c1bb9.jpg";